import { forwardRef } from 'react'

/**
 * Form wrapper rendering a <form> element and forwarding a ref to it (e.g. to trigger submit
 * programmatically from a parent component).
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className="form-view"] - CSS class applied to the form element.
 * @param {Function} props.onSubmit - Submit handler for the form.
 * @param {React.ReactNode} props.children - Form content.
 * @param {React.Ref} ref - Forwarded ref attached to the underlying form element.
 * @returns {JSX.Element}
 */
export default forwardRef(function FormLayout(
  { className = 'form-view', onSubmit, children },
  ref
) {
  return (
    <form
      ref={ref}
      className={className}
      onSubmit={onSubmit}
    >
      {children}
    </form>
  )
})
